import React from "react";
import styled from "styled-components";

export default styled.span`
    width: 50%;
    display: block;
    box-sizing: border-box;
    height: auto;
    font-size: 16px;
    padding-right: 9px;
    border: none;
    color: #717198;
    float: right;
    cursor: pointer;
    text-align: right;
    padding-top: 5px;
    
        display: ${(props) => (props.hidden ? "none" : "block")};
`;